import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

type Partner = {
  readonly id: "wusc" | "ceci" | "canada";
  readonly href: string;
  readonly src: string;
  readonly altKey:
    "shell.partnership.wuscAlt" | "shell.partnership.ceciAlt" | "shell.partnership.canadaAlt";
};

const PARTNERS: readonly Partner[] = [
  {
    id: "wusc",
    href: "https://wusc.ca/",
    src: "/partners/wusc.png",
    altKey: "shell.partnership.wuscAlt",
  },
  {
    id: "ceci",
    href: "https://ceci.ca/",
    src: "/partners/ceci.png",
    altKey: "shell.partnership.ceciAlt",
  },
  {
    id: "canada",
    href: "https://www.canada.ca/",
    // Official "En partenariat avec Canada" lockup: the wordmark already
    // carries the label, so this one renders as a plain logo.
    src: "/partners/canada-partnership-fr.png",
    altKey: "shell.partnership.canadaAlt",
  },
];

export function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="nbs-footer" aria-label={t("shell.footer")}>
      <section className="nbs-footer__partners" aria-label={t("shell.partnership.title")}>
        <ul className="nbs-footer__partners-logos">
          {PARTNERS.map((partner) => (
            <li
              key={partner.id}
              className={`nbs-footer__partner nbs-footer__partner--${partner.id}`}
            >
              <a
                href={partner.href}
                target="_blank"
                rel="noopener noreferrer"
                className="nbs-footer__partner-link"
                aria-label={t(partner.altKey)}
              >
                <img src={partner.src} alt={t(partner.altKey)} />
              </a>
            </li>
          ))}
        </ul>
      </section>
      <div className="nbs-footer__meta">
        <nav className="nbs-footer__legal" aria-label={t("legal.nav")}>
          <Link to="/politique-de-confidentialite">{t("legal.privacy")}</Link>
          <Link to="/politique-de-confidentialite#conditions">{t("legal.terms")}</Link>
        </nav>
        <p className="nbs-text nbs-text--sm nbs-text--muted">{t("app.copyright", { year })}</p>
      </div>
    </footer>
  );
}
